
import { Component, Inject, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import SimpleMap from '../../core/components/Map/SimpleMap.vue';
import SatellitalImagesStrip from './satellital/SatellitalImagesStrip.vue';
import SinisterActions from './SinisterActions.vue'
import SatellitalBandSelector from './satellital/SatellitalBandSelector.vue'
import { Bounds, FeatureCollection } from '../../shared/types/MapShapes';
import { ClaimManagementPort, ClaimsPort, UpdateClaimPolygonResponse } from '../../core/api/ports';
import { TenantConfig } from '../../tenants/types';
import { InjectionKey } from '../../core/injection-keys';
import { SatellitalImage, SatellitalImagesApiList } from '../../shared/types/satellital/satellital_images';
import LoadingIndicator from '../../core/components/Generics/LoadingIndicator.vue';
import DownloadButton from '../../core/components/Generics/Buttons/DownloadButton.vue';
import { NDVIInfo, SatellitalLayersInfo, ZonificationInfo } from '../../shared/types/satellital/layers';
import { EventBus, TypeEventBus } from '../../core/utils';
import { Sinister } from '../../shared/types/sinisters/sinisterInfo';
import moment from 'moment';
import { Note } from '../../shared/types/notes/notes';
import SwitchToggle from '../../core/components/Generics/SwitchToggle.vue'
import { SatellitalValues } from '../../shared/types/satellital/evolution_chart';
import ModalCreateItem from './modals/ModalCreateItem.vue';
import { showConfirmDialog, showErrorSnackbar, showInfoSnackbar, showSuccessSnackbar } from '../../shared/helpers/alerts-popups';
import { formatDate } from '../../core/utils/date-handlers';

@Component({
  components: {
    SimpleMap,
    SatellitalImagesStrip,
    LoadingIndicator,
    SatellitalBandSelector,
    SinisterActions,
    DownloadButton,
    SwitchToggle,
    ModalCreateItem
  },
})
/**
 * Mapa del siniestro: imágenes satelitales por banda, capas (zonificación / diferencial NDVI), notas y acciones.
 * Flags (desde `features` del tenant, los pasa la página): `editable` (editar/restaurar el polígono del siniestro)
 * y `allowSplit` (dividir el item). La edición usa `ClaimManagementPort`, que solo existe si `editable`.
 */
export default class SinisterMapLayers extends Vue {
  @Inject(InjectionKey.Tenant) readonly tenant!: TenantConfig;
  @Inject(InjectionKey.ClaimsApi) readonly claimsApi!: ClaimsPort;
  @Inject({ from: InjectionKey.ClaimManagementApi, default: null }) readonly claimManagementApi!: ClaimManagementPort | null;
  /** `features.editPolygonInClaim`: polígono editable + "Restaurar polígono". */
  @Prop({ default: false }) readonly editable!: boolean;
  /** `features.splitPolygon`: "Dividir Item de Siniestro". */
  @Prop({ default: false }) readonly allowSplit!: boolean;
  @Prop({ default: null }) readonly itemPolygon!: FeatureCollection;
  @Prop({ default: () => null }) sinisterInfo!: Sinister;
  /** Nota seleccionada / en hover, compartida con el listado de notas (la guarda el contenedor de la página). */
  @Prop({ default: null }) selectedNoteId!: number | null;
  @Prop({ default: null }) hoveredNoteId!: number | null;
  hiddenImageIds: Array<number | string> = [];

  showNdvi: boolean = false;
  showPolygon: boolean = true;
  pendingSatellitalImages: boolean = false;
  pendingLayersInfo: boolean = false;
  showZonification: boolean = false;
  satellitalLayersInfo: SatellitalLayersInfo = {
    zonified: {
      date: null,
      png_url: null,
      bar_url: '',
      total_area: null,
      zones: [],
      bounds: null
    },
    ndvi: {
       initial_date: null,
        final_date: null,
       bar_url: '',
       png_url: null,
        total_area: null,
        zones: [],
        bounds: null
    }
  };

  imagesGroupedByBand: SatellitalImagesApiList = {};
  bands: string[] = [];
  selectedBand: string | null = null;
  visibleNotes: boolean = true;
  // Se actualiza con `map-is-satellital-changed` de SimpleMap; arranca según `features.satelliteMapByDefault` (en created:
  // los inicializadores de campos no ven valores inyectados con useDefineForClassFields).
  mapIsSatellital: boolean = false;
  notes: Note[] = [];
  editPolygonModalVisible: boolean = false;

  visibleModalCreateItem: boolean = false;
  selectedPolygonsCountForCreateItem: number = 0;
  private createItemPollTimer: number | null = null;
  applyingCreateItem: boolean = false;
  applyingRestorePolygon: boolean = false;

  imagesOfBand: SatellitalImage[] = [];
  selectedImage: SatellitalImage | null = null;
  private lastBaseUrl: string | null = null;
  currentCarouselIndex: number = 0;
  rgbAndNdviValues: SatellitalValues = {
      NDVI: [],
      RGB: []
  }

  private refreshActiveOverlays() {
  if (this.mapRef) {
    if (this.showZonification) {
      this.hideZonif();
      this.drawZonif();
    }
    if (this.showNdvi) {
      this.hideNdvi();
      this.drawNdvi();
    }
  }
}


    get activeLegendUrl(): string | null {
      if (this.showZonification) {
        return this.satellitalLayersInfo.zonified.bar_url
      }
      if (this.showNdvi) {
          return this.satellitalLayersInfo.ndvi.bar_url
      }
      if(this.selectedImage && this.selectedImage.bar_url){
        return this.selectedImage.bar_url
      }

       return null;
    }


  @Watch('satellitalLayersInfo', { deep: true })
  onLayersInfoDeepChange(value) {
    this.refreshActiveOverlays();
  }


  onVisibleNotesChange(value: boolean) {
    if (value) {
      this.seeNotesInMap(this.notes);
    } else {
      if (this.mapRef) {
        this.mapRef.removeRanchNotesMarkers();
      }
    }
  }

  created(){
    this.mapIsSatellital = this.tenant.features.satelliteMapByDefault;
    this.fetchData();
  }

  seeNotesInMap(notes: Note[]) {
    let self = this;
    this.notes = notes;
    if(this.mapRef){
      self.mapRef.removeRanchNotesMarkers();

      this.$nextTick(() => {
        let markersWithLocation:Array<object> = [];
        if(notes.length > 0){
            markersWithLocation = [...notes].filter(note => note['location'] !== null)
            self.mapRef.displayRanchNotesMarkers(markersWithLocation);
        }
      })
    }
  }

  private applyInitialSelection() {
  let imgs = this.imagesOfBand || [];
  if (!imgs.length) {
    this.changeCarouselIndex(-1);
    this.selectedImage = null;
    this.onSelectedImageChange(null);
    return;
  }

  let idx = imgs.length - 1;

  let eventDateStr = (this.sinisterInfo && this.sinisterInfo.event_date) ? this.sinisterInfo.event_date : null;
  if (eventDateStr) {
    let eventDate = moment(eventDateStr);
    for (let i = 0; i < imgs.length; i++) {
      if (moment(imgs[i].date).isAfter(eventDate)) {
        idx = i;
        break;
      }
    }
  }

  this.changeCarouselIndex(idx);
  this.selectedImage = imgs[idx];
  this.onSelectedImageChange(this.selectedImage);
}

  get currentZonifiedDate() {
    if (
      this.satellitalLayersInfo &&
      this.satellitalLayersInfo.zonified &&
      this.satellitalLayersInfo.zonified.date
    ) {
      return this.satellitalLayersInfo.zonified.date;
    }
    return null;
  }



   get zonificationDisabled() {
    return (
      this.pendingLayersInfo ||
      !(
        this.satellitalLayersInfo &&
        this.satellitalLayersInfo.zonified &&
        this.satellitalLayersInfo.zonified.png_url
      )
    );
  }

  get zonificationTooltip() {
    if (this.pendingLayersInfo) return 'Cargando zonificación...';
    if (
      !(
        this.satellitalLayersInfo &&
        this.satellitalLayersInfo.zonified &&
        this.satellitalLayersInfo.zonified.png_url
      )
    ) {
      return 'No hay imagen de zonificación';
    }
    return '';
  }

  get polygonDisabled() {
    return !this.itemPolygon; 
  }

  get polygonTooltip() {
    if (!this.itemPolygon) return 'No hay polígono disponible';
    return '';
  }

  get ndviDisabled() {
    return (
      this.pendingLayersInfo ||
      !(
        this.satellitalLayersInfo &&
        this.satellitalLayersInfo.ndvi &&
        this.satellitalLayersInfo.ndvi.png_url
      )
    );
  }

  get ndviTooltip() {
    if (this.pendingLayersInfo) return 'Cargando diferencial NDVI...';
    if (
      !(
        this.satellitalLayersInfo &&
        this.satellitalLayersInfo.ndvi &&
        this.satellitalLayersInfo.ndvi.png_url
      )
    ) {
      return 'No hay imagen NDVI disponible';
    }
    return '';
  }

  get mapRef(): any {
    return this.$refs.sinisterMap;
  }

  get polygonName(): string {
    // Return a name for the polygon - use claim_id or a default name
    if (this.sinisterInfo && this.sinisterInfo.claim_id) {
      return this.sinisterInfo.claim_id;
    }
    return 'Polígono';
  }



  showBase() {
    const url   = this.selectedImage && this.selectedImage.png_url;
    const bounds= this.selectedImage && this.selectedImage['bounds'];
    if (!url || !bounds || !this.mapRef) return;

    if (this.lastBaseUrl) {
      this.mapRef.hideGroundOverlayFromMap(this.lastBaseUrl);
    }
    this.mapRef.setGroundOverlayInMap(url, bounds, true);
    this.lastBaseUrl = url;
  }

  showZonif() {
    const z = this.satellitalLayersInfo && this.satellitalLayersInfo.zonified;
    const url = z && z.png_url;
    const bounds = z && z['bounds'];
    if (url && bounds && this.mapRef) this.mapRef.setGroundOverlayInMap(url, bounds, false);
  }

  hideZonif() {
    const z = this.satellitalLayersInfo && this.satellitalLayersInfo.zonified;
    const url = z && z.png_url;
    if (url && this.mapRef) this.mapRef.hideGroundOverlayFromMap(url);
  }

  hideNdvi() {
    const n = this.satellitalLayersInfo && this.satellitalLayersInfo.ndvi;
    const url = n && n.png_url;
    if (url && this.mapRef) this.mapRef.hideGroundOverlayFromMap(url);
  }

  hideAllOverlays() {
    if (this.mapRef) this.mapRef.hideGroundOverlaysFromMap();
    this.lastBaseUrl = null;
  }

  toggleShowZonification() {
    this.showZonification = !this.showZonification;

    if (this.showZonification) {
      if (this.showNdvi) {
        this.showNdvi = false;
        this.hideNdvi();
      }
      this.drawZonif();
    } else {
      this.hideZonif();
    }
  }

  drawZonif() {
    const z = this.satellitalLayersInfo && this.satellitalLayersInfo.zonified;
    const url = z && z.png_url;
    const bounds = z && z.bounds;
    if (url && bounds && this.mapRef) this.mapRef.setGroundOverlayInMap(url, bounds, false);
  }

  toggleShowNdvi() {
    this.showNdvi = !this.showNdvi;

    if (this.showNdvi) {
      if (this.showZonification) {
        this.showZonification = false;
        this.hideZonif();
      }
      this.drawNdvi();
    } else {
      this.hideNdvi();
    }
  }

  drawNdvi() {
    const n = this.satellitalLayersInfo && this.satellitalLayersInfo.ndvi;
    const url = n && n.png_url;
    const bounds = n.bounds;
    if (url && bounds && this.mapRef) this.mapRef.setGroundOverlayInMap(url, bounds, false);
  }

  async fetchData() {
    this.pendingSatellitalImages = true;
    this.pendingLayersInfo = true;

    const imagesP = this.claimsApi.getSatellitalImages(this.sinisterInfo.id);
    

    this.changeLoadingMap(true)
    imagesP
      .then((response) => {
        let images = response['images'];
        this.rgbAndNdviValues = response['values'];
        this.imagesGroupedByBand = images;
        this.bands = Object.keys(images);
        this.selectedBand = this.bands[0] || null;
        this.onBandChange(this.selectedBand)
        this.imagesOfBand = this.selectedBand ? this.imagesGroupedByBand[this.selectedBand] : [];
        this.applyInitialSelection();
        this.showBase();
      })
      .catch((e) => {
        this.imagesOfBand = []
        console.error('Error imágenes', e)
      })
      .finally(() => {
        this.pendingSatellitalImages = false;
        this.refreshLayersInfo();
        this.processingNdviDiff(false);
        this.processingZonification(false)
      });

    
  }

  refreshLayersInfo(){
    let self = this;
    const layersP = this.claimsApi.getSatellitalLayers(this.sinisterInfo.id);
    layersP
      .then((layersInfo: SatellitalLayersInfo) => {
        this.satellitalLayersInfo = layersInfo;
        this.satellitalInfoChanged(layersInfo)

        if (this.showZonification) this.showZonif();
        if (this.showNdvi) this.drawNdvi();
      })
      .catch((e) => console.error('Error layers', e))
      .finally(() => {
          this.pendingLayersInfo = false;
          this.emitRgbNdviToChart(this.rgbAndNdviValues);
      });
  }
  

  onSelectBand(band: string | null) {
    this.selectedBand = band;
    this.onBandChange(band);

    this.imagesOfBand = band ? (this.imagesGroupedByBand[band] || []) : [];

    this.applyInitialSelection();
    this.showBase();
  }

  clickedSatelliteImage(index: number, image?: any) {
    if (index === -1) {
      this.changeCarouselIndex(-1);
      this.selectedImage = null;
      this.onSelectedImageChange(null);
      if (this.lastBaseUrl && this.mapRef) {
        this.mapRef.hideGroundOverlayFromMap(this.lastBaseUrl);
        this.lastBaseUrl = null;
      }
      return;
    }

    const img = image || (this.imagesOfBand && this.imagesOfBand[index]);
    if (!img) return;

    if (this.showZonification) {
      this.showZonification = false;
      this.hideZonif();
    }
    
    if (this.showNdvi) {
      this.showNdvi = false;
      this.hideNdvi();
    }

    this.changeCarouselIndex(index);
    this.selectedImage = img;
    this.onSelectedImageChange(img);
    this.showBase();
  }

  changeCarouselIndex(newValue: number){
    this.currentCarouselIndex = newValue
  }

  @Emit()
  emitRgbNdviToChart(values){}

  @Emit('select-note')
  onSelectNote(noteId: number | null) {
    return noteId;
  }

  @Emit()
  @Watch('currentCarouselIndex')
  onCarouselIndexChange(value){}

  @Emit()
  onSelectedImageChange(value){}

  @Emit()
  processingZonification(value){}

  @Emit()
  processingNdviDiff(value){}

  onSuccessZonified(newZonifiedInfo: ZonificationInfo){
    this.satellitalLayersInfo.zonified = newZonifiedInfo;
    this.satellitalInfoChanged(this.satellitalLayersInfo)
  }

  onSuccessNDVIDiff(newNDVIInfo: NDVIInfo){
    this.satellitalLayersInfo.ndvi = newNDVIInfo;
    this.satellitalInfoChanged(this.satellitalLayersInfo)
  }

  @Emit()
  satellitalInfoChanged(newData: SatellitalLayersInfo){}

  @Emit()
  changeLoadingMap(value: boolean){}

  @Emit()
  onBandChange(value: string | null){}

  async onPolygonSave(polygon: google.maps.LatLngLiteral[][][][]){
    if (!this.editable || !this.claimManagementApi) {
      return;
    }
    if (!this.sinisterInfo || !this.sinisterInfo.ranch || !this.sinisterInfo.ranch.id) {
      EventBus.$emit(TypeEventBus.SNACKBAR, {
        message: 'No hay información disponible',
        color: 'error',
        timeout: 4000
      });
      return;
    }

    // Send polygon in the same format as ItemServices.getPolygonArea / addPolygonToItem
    // This is the raw 4D array format: PolyCoords = google.maps.LatLngLiteral[][][][]
    // Use ranch.id (not claim.id) as per the endpoint requirement
    try {

      if(polygon && polygon.length == 0) return 
      const response = await this.claimManagementApi.updateClaimPolygon(
        this.sinisterInfo.ranch.id,
        this.sinisterInfo.id,
        polygon);
      const baseMessage = response.message || 'Polígono actualizado correctamente';
      const { message, timeout } = this.appendSatellitalEtaToMessage(baseMessage, response);

      EventBus.$emit(TypeEventBus.SNACKBAR, {
        message: message,
        color: response.message ? 'info' : 'success',
        timeout: timeout
      });
      this.applyBackendPolygon(response);
      this.$emit('polygon-updated', {
        ranch_area: response.ranch_area,
        polygon: response.polygon,
        using_original_polygon: false
      });
    } catch (error: any) {
      console.error('Error updating polygon:', error);
      const backendMsg = error && error.response && error.response.data && (error.response.data.message || error.response.data.detail);
      EventBus.$emit(TypeEventBus.SNACKBAR, {
        message: backendMsg || 'Error al actualizar el polígono',
        color: 'error',
        timeout: 4000
      });
    }
  }

  applyBackendPolygon(response: UpdateClaimPolygonResponse) {
    const polygon = response && response.polygon;
    if (!polygon || !polygon.features || polygon.features.length === 0) {
      return;
    }
    const mapRef = this.$refs.sinisterMap as SimpleMap;
    if (mapRef && typeof mapRef.addGeoJson === 'function') {
      mapRef.addGeoJson(polygon);
    }
  }

  private appendSatellitalEtaToMessage(
    baseMessage: string,
    response: UpdateClaimPolygonResponse,
  ): { message: string; timeout: number } {
    let message = baseMessage;
    let timeout = 4000;
    if (response.force_generate_satellital_images !== undefined) {
      const minutes = response.force_generate_satellital_images ? 20 : 5;
      message += '<br>Las imágenes satelitales estarán disponibles en aproximadamente ' + minutes + ' minutos.';
      timeout = 6000;
    }
    return { message, timeout };
  }

  async onRestorePolygonClick() {
    if (!this.editable || !this.claimManagementApi) {
      return;
    }
    if (!this.sinisterInfo || !this.sinisterInfo.ranch || !this.sinisterInfo.ranch.id) {
      showErrorSnackbar('No hay información disponible');
      return;
    }

    if (this.sinisterInfo.using_original_polygon) {
      showErrorSnackbar('No se puede restaurar el polígono.<br>La versión actual es la original');
      return;
    }

    if (this.editPolygonModalVisible) {
      EventBus.$emit(TypeEventBus.CANCEL_POLYGON_EDITION);
    }

    const confirmed = await showConfirmDialog(
      'Restaurar polígono',
      'Esta acción sobreescribirá el polígono actual.<br><br>¿Desea continuar?',
    );
    if (!confirmed) {
      return;
    }

    this.applyingRestorePolygon = true;
    try {
      const response = await this.claimManagementApi.restoreClaimPolygon(
        this.sinisterInfo.ranch.id,
        this.sinisterInfo.id,
      );
      this.applyBackendPolygon(response);
      this.$emit('polygon-updated', {
        ranch_area: response.ranch_area,
        polygon: response.polygon,
        using_original_polygon: response.using_original_polygon,
      });

      let baseMessage = 'Polígono restaurado con éxito';
      if (response.original_polygon_date) {
        // La "Z" hace que formatDate convierta a hora local (resta el offset); se recorta para mostrar la hora tal cual la manda el backend.
        const normalizedDate = response.original_polygon_date.replace(
          /\.\d+Z$/,
          '',
        );
        baseMessage += '<br>Versión del polígono: ' + formatDate(normalizedDate);
      }
      const { message, timeout } = this.appendSatellitalEtaToMessage(
        baseMessage,
        response,
      );
      EventBus.$emit(TypeEventBus.SNACKBAR, {
        message,
        color: 'success',
        timeout: timeout + 3000,
      });
    } catch (error: any) {
      console.error('Error restoring polygon:', error);
      const backendMsg =
        error &&
        error.response &&
        error.response.data &&
        (error.response.data.message || error.response.data.detail);
      showErrorSnackbar(backendMsg || 'Error al restaurar el polígono');
    } finally {
      this.applyingRestorePolygon = false;
    }
  }

  onGeometryModified(polygon: google.maps.LatLngLiteral[][][][], isModified: boolean){
    // This is called while the polygon is being modified
    // You can add real-time feedback here if needed
  }

  onCreateItemClick() {
    if (this.editPolygonModalVisible) {
      EventBus.$emit(TypeEventBus.CANCEL_POLYGON_EDITION);
    }
    this.visibleModalCreateItem = true;
    this.selectedPolygonsCountForCreateItem = 0;
    this.$nextTick(() => {
      const mapRef = this.$refs.sinisterMap as SimpleMap;
      if (mapRef && typeof mapRef.enterSelectionModeForCreateItem === 'function') {
        mapRef.enterSelectionModeForCreateItem();
      }
      this.createItemPollTimer = window.setInterval(() => {
        if (this.$refs.sinisterMap && typeof (this.$refs.sinisterMap as SimpleMap).getMarkedPolygonsCount === 'function') {
          this.selectedPolygonsCountForCreateItem = (this.$refs.sinisterMap as SimpleMap).getMarkedPolygonsCount();
        }
      }, 400) as unknown as number;
    });
  }

  closeModalCreateItem() {
    this.visibleModalCreateItem = false;
    if (this.createItemPollTimer != null) {
      window.clearInterval(this.createItemPollTimer);
      this.createItemPollTimer = null;
    }
    const mapRef = this.$refs.sinisterMap as SimpleMap;
    if (mapRef && typeof mapRef.exitDeleteMode === 'function') {
      mapRef.exitDeleteMode();
    }
  }

  async onSaveCreateItem(newItemId: string) {
    const originItemId = (this.sinisterInfo && this.sinisterInfo.ranch && this.sinisterInfo.ranch.name) ? this.sinisterInfo.ranch.name : '';
    if (!originItemId || (newItemId || '').trim() === originItemId) {
      showErrorSnackbar('Ingrese un nuevo nombre para el item');
      return;
    }
    const mapRef = this.$refs.sinisterMap as SimpleMap;
    if (!mapRef || typeof mapRef.getCoordsFromMarkedPolygons !== 'function') {
      showErrorSnackbar('No se pudo crear el item');
      return;
    }
    const polygons = mapRef.getCoordsFromMarkedPolygons();
    if (!polygons || polygons.length === 0) {
      showErrorSnackbar('Seleccione al menos un polígono');
      return;
    }
    if (!this.sinisterInfo || !this.sinisterInfo.ranch || !this.claimManagementApi) {
      showErrorSnackbar('No se pudo crear el item');
      return;
    }
    this.applyingCreateItem = true;
    try {
      const response = await this.claimManagementApi.postRanchSplit(
        this.sinisterInfo.ranch.id,
        this.sinisterInfo.id,
        polygons,
        (newItemId || '').trim()
      );
      const baseMessage = response.message || 'Item creado correctamente';
      let message = baseMessage;
      let timeout = 4000;

      if (response.force_generate_satellital_images !== undefined) {
        const minutes = response.force_generate_satellital_images ? 20 : 5;
        message = baseMessage + '<br>Las imágenes satelitales estarán disponibles en aproximadamente ' + minutes + ' minutos.';
        timeout = 6000;
      }

      showSuccessSnackbar(message, timeout);
      this.closeModalCreateItem();
      this.$emit('claim-detail-refresh');
    } catch (error: any) {
      console.error('Error creating item:', error);
      const backendMsg = error && error.response && error.response.data && (error.response.data.message || error.response.data.detail);
      const msg = backendMsg || 'No se pudo crear el item';
      showErrorSnackbar(msg);
    } finally {
      this.applyingCreateItem = false;
    }
  }
}
